import { createSelector } from 'reselect';
import { leaderboardNavSelector } from '.';

/**
 * @returns {( object ) => object|null} Season.
 */
export const seasonSelector = createSelector(
    leaderboardNavSelector,
    (state) => state.seasons,
    (nav, seasons) => {
        try {
            return seasons[`competition_${nav.competition.id}`][
                `season_${nav.season.id}`
            ];
        } catch (err) {
            return null;
        }
    }
);